import script from "./LibaoOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./LibaoOrder.vue?vue&type=script&setup=true&lang=js"

import "./LibaoOrder.vue?vue&type=style&index=0&id=15d8159a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d8159a"]])

export default __exports__